<div>
  <form [class.blocked]="submitted && form.valid" (ngSubmit)="onSubmit()" [formGroup]="form">
    <div class="form-group">
      <label for="cardNumber" [innerHtml]="'FORM.CARD_NUM' | translate"></label>
      <div class="form-input" [ngClass]="{'invalid': form.controls['cardNumber'].invalid && firstSubmitted}">
        <input [placeholder]="'FORM.CARD_NUM_PH' | translate" name="cardNumber" id="cardNumber" autocomplete="off" required pattern="([0-9]){4,4}" minlength="4" maxlength="4" type="text" (keyup)="submitted=false;" autofocus formControlName="cardNumber" />
      </div>
      <div class="form-error" [hidden]="!(form.controls['cardNumber'].invalid && firstSubmitted)">
        <span></span>
        <span [innerHtml]="'FORM.CARD_NUM_ERROR' | translate"></span>
      </div>
    </div>

    <div class="form-group">
      <label for="mpId" [innerHtml]="'FORM.MP_NUM' | translate"></label>
      <div class="form-input" [ngClass]="{'invalid': form.controls['mpId'].invalid && firstSubmitted}">
        <input tabindex="0" aria-label="MileagePlus account number" [placeholder]="'FORM.MP_NUM_PH' | translate" name="mpId" autocomplete="off" required name="mpId" pattern="([a-zA-Z0-9]){8,8}" minlength="8" maxlength="8" type="text" (keyup)="submitted=false;" formControlName="mpId"  />
      </div>
      <div class="form-error" [hidden]="!(form.controls['mpId'].invalid && firstSubmitted)">
        <span></span>
        <span [innerHtml]="'FORM.MP_NUM_PH' | translate"></span>
      </div>
    </div>

    <div class="form-forgot">
      <a aria-label="forgot your MileagePlus number? link, opens in a new tab" [href]="'FORM.FORGOT_LINK' | translate" target="_blank" [innerHtml]="'FORM.FORGOT' | translate"></a>
    </div>

    <div *ngIf="!isProduction" class="spacer"></div>

    <div class="form-btn">
      <button tabindex="0">
        <span [class.show]="loading">
          <svg class="form-loading" width="38" height="20" viewBox="0 0 38 38" xmlns="http://www.w3.org/2000/svg" stroke="#fff">
            <g fill="none" fill-rule="evenodd">
              <g transform="translate(1 1)" stroke-width="2">
                <circle stroke-opacity=".5" cx="18" cy="18" r="18" />
                <path d="M36 18c0-9.94-8.06-18-18-18">
                  <animateTransform attributeName="transform" type="rotate" from="0 18 18" to="360 18 18" dur="1s" repeatCount="indefinite" />
                </path>
              </g>
            </g>
          </svg>
        </span>
        <span [class.show]="!loading" [innerHtml]="'FORM.CTA_BTN' | translate"></span>
      </button>
      <div tabindex="0" class="info-terms" id="info-terms" [innerHtml]="'OFFER.TERMS_TITLE' | translate" (click)="showTerms = !showTerms" (keydown)="onKeydown($event)"></div>
      <a [href]="'CONSENTS.PRIVACY_POLICY_LINK' | translate" tabindex="0" class="info-terms" [attr.aria-label]="'CONSENTS.PRIVACY_POLICY_ARIA' | translate" [innerHtml]="'CONSENTS.PRIVACY_POLICY' | translate" target="_blank"></a>
      <div role="button" class="cookie-consent" tabindex="0" [innerHtml]="'CONSENTS.COOKIE_PREFS' | translate"></div>
    </div>
  </form>
</div>

<app-terms [showTerms]="showTerms" (goClose)="onCloseTerms()"></app-terms>